import axios from '../http'

function add(data) {
    return axios.post('/event/game/add', data);
}

function delByIds(data) {
    return axios.post('/event/game/delByIds', data);
}

function init(id) {
    return axios.get('/event/game/init?id=' + id);
}

function update(data) {
    return axios.post('/event/game/update', data);
}

function adjust(data) {
    return axios.post('/event/game/adjust', data);
}

function query(data) {
    return axios.post('/event/game/query', data);
}

function get(id) {
    return axios.get('/event/game/get?id=' + id);
}

function entryStart(id) {
    return axios.get('/event/game/entryStart?id=' + id);
}

function revertEntryStart(id) {
    return axios.get('/event/game/revertEntryStart?id=' + id);
}


function entryEnd(id) {
    return axios.get('/event/game/entryEnd?id=' + id);
}


function revertEntryEnd(id) {
    return axios.get('/event/game/revertEntryEnd?id=' + id);
}

function revertHeatGrouped(id) {
    return axios.get('/event/game/revertHeatGrouped?id=' + id);
}

function revertScheduled(id) {
    return axios.get('/event/game/revertScheduled?id=' + id);
}

function getOptions() {
    return axios.post('/event/game/getOptions');
}

function printEntry(id) {
    const url = "/event/game/printEntry?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}


function exportEntry(id){
    const url = "/event/game/exportEntry?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Entries by Regatta.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}


export default {
    query,
    get,
    add,
    update,
    adjust,
    delByIds,
    entryStart,
    revertEntryStart,
    entryEnd,
    revertEntryEnd,
    revertHeatGrouped,
    revertScheduled,
    getOptions,
    printEntry,
    exportEntry,
    init
    

}